//
import {queryList, getAddClient,
  getUpdateClient, getUpdateClientList, getDeleteClientList, getInitUserInfo, getInitMenuInfo,
  getInitClientInfo, getInitRoleInfo, getInitPermissionInfo, getInitPageOpInfo,getResetClientSecret,getExportClientData} from './../api';
import { Message } from 'element-ui';
const client = {
    namespaced: true,
    state: {
        successCode:200,
        resp:null,
        addClientData:null,
        upDateClientData:null,
        updateClientList:null,
        deleteClientList:null,
        total:null,
        initUserInfo:null,
        initMenuInfo:null,
        initClientInfo:null,
        initRoleInfo:null,
        initPermissionInfo:null,
        initPageOpInfo:null,
        resetClientSecret:null,
        exportClientData:null,
    },
    mutations: {
      QUERY_LIST(state,resp){
            if (resp.code === state.successCode){
              Message({showClose: true, message: resp.msg, type: 'success'});
            }
            state.resp = resp.obj || [];
            state.total = resp.total
        },
      GET_ADD_CLIENT(state, data){
          state.addClientData = data
      },
      GET_UPDATE_CLIENT(state, data){
        state.upDateClientData = data
      },
      GET_UPDATE_CLIENT_LIST(state, data){
        state.updateClientList = data
      },
      GET_RESET_CLIENT_SECRET(state, data){
        state.resetClientSecret = data
      },
      GET_DELETE_CLIENT_LIST(state, data){
        state.deleteClientList = data
      },
      GET_INIT_USER_INFO(state,data){
        state.initUserInfo = data;
      },
      GET_INIT_MENU_INFO(state,data){
        state.initMenuInfo = data;
      },
      GET_INIT_CLIENT_INFO(state,data){
        state.initClientInfo = data;
      },
      GET_INIT_PERMISSION_INFO(state,data){
        state.initPermissionInfo = data;
      },
      GET_INIT_ROLE_INFO(state,data){
        state.initRoleInfo = data;
      },
      GET_INIT_PAGE_OP_INFO(state,data){
        state.initPageOpInfo = data;
      },
      GET_EXPORT_CLIENT_DATA(state,data){
        state.exportClientData = data;
      }

    },
    actions: {

       async queryList({commit}, obj){
           let resp = await queryList(obj);
           commit('QUERY_LIST', resp);
        },
        async getAddClient({commit}, obj){
          let resp = await getAddClient(obj);
          commit('GET_ADD_CLIENT', resp);
        },
        async getUpdateClient({commit}, obj){
          let resp = await getUpdateClient(obj);
          commit('GET_UPDATE_CLIENT', resp);
        },
        async getUpdateClientList({commit}, obj){
          let resp = await getUpdateClientList(obj);
          commit('GET_UPDATE_CLIENT_LIST', resp);
        },
        async getResetClientSecret({commit}, obj){
          let resp = await getResetClientSecret(obj);
          commit('GET_RESET_CLIENT_SECRET', resp);
        },
        async getDeleteClientList({commit}, obj){
        let resp = await getDeleteClientList(obj);
        commit('GET_DELETE_CLIENT_LIST', resp);
      },
      async getInitUserInfo({commit}){
        let resp = await getInitUserInfo();
        commit('GET_INIT_USER_INFO', resp);
      },
      async getInitMenuInfo({commit}){
        let resp = await getInitMenuInfo();
        commit('GET_INIT_MENU_INFO', resp);
      },
      async getInitClientInfo({commit}){
        let resp = await getInitClientInfo();
        commit('GET_INIT_CLIENT_INFO', resp);
      },
      async getInitRoleInfo({commit}){
        let resp = await getInitRoleInfo();
        commit('GET_INIT_ROLE_INFO', resp);
      },
      async getInitPermissionInfo({commit}){
        let resp = await getInitPermissionInfo();
        commit('GET_INIT_PERMISSION_INFO', resp);
      },
      async getInitPageOpInfo({commit}){
        let resp = await getInitPageOpInfo();
        commit('GET_INIT_PAGE_OP_INFO', resp);
      },
      async getExportClientData({commit}, obj){
        let resp = await getExportClientData(obj);
        commit('GET_EXPORT_CLIENT_DATA', resp);
      },


    }
}

export default client



// WEBPACK FOOTER //
// ./src/page/auth/client/store/client.store.js